import { Container, Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import { Helmet } from "react-helmet";

export default function ComparisonsAi() {
  const base =
    (typeof window !== "undefined" && window.location && window.location.origin) ||
    "https://talk-mate-backend.web.app";
  const enUrl = `${base}/en/compare-chatbot`;
  const frUrl = `${base}/fr/comparatif-chatbot-ia`;

  return (
    <Container sx={{ py: 6 }}>
      <Helmet>
        <title>Talkmate – AI chatbot alternative for websites</title>
        <meta
          name="description"
          content="Create an AI chatbot, embed it, share a link, and switch to manual replies when needed."
        />
        <meta property="og:title" content="Talkmate – AI chatbot alternative" />
        <meta
          property="og:description"
          content="Talkmate lets you add an embed or link, configure your context, and hand off to a human operator if needed."
        />
        <meta name="robots" content="index, follow" />
        <link rel="alternate" href={enUrl} hrefLang="en" />
        <link rel="alternate" href={frUrl} hrefLang="fr" />
        <link rel="canonical" href={enUrl} />
      </Helmet>

      <Typography variant="h3" fontWeight={800} gutterBottom>
        Talkmate: AI chatbot alternative for websites
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Talkmate lets you build an AI agent, add a widget or iframe, share a public link, and do manual handoff without
        code.
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Key points
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Widget, public link, iframe to answer visitors automatically." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Manual mode: stop the AI and respond yourself when necessary." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Multilingual, contextual, configurable in minutes." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Use cases
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="FAQ and customer support on your site; lead capture." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Product assistants for SaaS, agencies, e-commerce." />
          </ListItem>
          <ListItem>
            <ListItemText primary="24/7 answers with optional human intervention." />
          </ListItem>
        </List>
      </Box>
    </Container>
  );
}
